/* Probably Late — cart glue
   1) Keeps every [data-pl-cart-count] in sync with the real cart.
   2) Makes [data-pl-cart-toggle] open Dawn's cart drawer instead of
      navigating away (falls back to the /cart page if no drawer). */
(function () {
  function setCount(n) {
    document.querySelectorAll('[data-pl-cart-count]').forEach(function (el) {
      el.textContent = n;
    });
  }

  function refreshCount() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        setCount(cart.item_count);
        syncEmptyState(cart.item_count);
        return cart;
      })
      .catch(function () {});
  }

  // Dawn publishes 'cart-update' after add / change / remove
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (payload) {
      if (payload && payload.cartData && typeof payload.cartData.item_count === 'number') {
        setCount(payload.cartData.item_count);
      } else {
        refreshCount();
      }
    });
  }

  // AJAX add-to-cart for [data-pl-add] buttons (pl-caps cards). Renders
  // Dawn's cart drawer with fresh sections when available, else just
  // refreshes the count.
  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('[data-pl-add]') : null;
    if (!btn) return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) {
      // No product wired up — fall through to the card link if provided
      var url = btn.getAttribute('data-url');
      if (url && url !== '#') window.location.href = url;
      return;
    }

    event.preventDefault();
    if (btn.disabled) return;

    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var drawer = document.querySelector('cart-drawer');
    var body = { id: Number(variantId), quantity: 1 };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) {
        return s.id;
      });
      body.sections_url = window.location.pathname;
    }

    // The button eases away as the cart drawer slides in — the label never
    // changes (see .is-adding in the section CSS)
    if (btn.dataset.plBusy === '1') return;
    var label = btn.textContent;
    var fade = btn.closest('.pl-coll__actions') || btn;
    btn.dataset.plBusy = '1';
    btn.setAttribute('aria-busy', 'true');
    // NB: the fade is applied on response, in step with the drawer opening —
    // fading here would leave a dead gap while the request is in flight

    var reset = function () {
      fade.classList.remove('is-adding');
      btn.removeAttribute('aria-busy');
      btn.dataset.plBusy = '';
      btn.textContent = label;
    };

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        if (res.status) throw new Error(res.description || 'Add to cart failed');
        // fade the button out at the same moment the drawer starts sliding in
        fade.classList.add('is-adding');
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(res);
          syncEmptyState(res.item_count);
          /* renderContents replaces #CartDrawer's innerHTML, so .drawer__inner
             is a brand-new node. If the browser never paints it at its start
             position, adding `active` jumps straight to the end and the slide
             is skipped — which is why add-to-cart opened without the easing
             that the cart link gets. Force the start state to flush first. */
          var panel = drawer.querySelector('.drawer__inner');
          if (panel) void panel.offsetWidth;
        }
        refreshCount();
        // the button stays hidden for as long as the drawer is open, and
        // only comes back once the shopper closes it
        restoreWhenDrawerCloses(reset);
      })
      .catch(function () {
        fade.classList.remove('is-adding');
        btn.textContent = 'Try again';
        setTimeout(reset, 1500);
      });
  });

  /* Keeps the faded-out button hidden while the cart drawer is on screen.
     Dawn toggles `active` on <cart-drawer>, so wait for it to open and then
     restore once it closes (with a safety net if it never opens). */
  function restoreWhenDrawerCloses(reset) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof MutationObserver === 'undefined') {
      setTimeout(reset, 700);
      return;
    }

    var opened = drawer.classList.contains('active');
    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      observer.disconnect();
      reset();
    };

    var observer = new MutationObserver(function () {
      if (drawer.classList.contains('active')) {
        opened = true;
        return;
      }
      if (opened) finish();
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });

    // if the drawer never opens (no drawer on the page, or an error), don't
    // strand the button in its hidden state
    setTimeout(function () {
      if (!opened) finish();
    }, 2000);
  }

  /* Dawn stamps `is-empty` on <cart-drawer> from Liquid at page load and
     renderContents only re-renders the drawer's inner HTML — so after an
     AJAX add the stale class keeps the item list hidden (empty-looking,
     broken drawer). Keep the flag in step with the real item count. */
  function syncEmptyState(itemCount) {
    var empty = !itemCount;
    ['cart-drawer', '.drawer__inner', '.cart-drawer__footer', '#main-cart-footer'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.classList.toggle('is-empty', empty);
      });
    });
  }

  /* Dawn's CartItems.updateQuantity re-renders a fixed list of sections and
     does `document.getElementById(section.id).querySelector(...)` with no null
     check. One of the sections it always asks for is `cart-icon-bubble`, which
     only exists in Dawn's own header — this theme uses pl-header, so the lookup
     returned null, threw, and the catch painted "There was an error while
     updating your cart" over an update that had in fact succeeded.

     Drop any section that is not actually on the page; the counts in the
     header are kept fresh by refreshCount() either way. */
  ['cart-items', 'cart-drawer-items'].forEach(function (tag) {
    var El = window.customElements && customElements.get(tag);
    if (!El || !El.prototype.getSectionsToRender) return;
    var original = El.prototype.getSectionsToRender;
    El.prototype.getSectionsToRender = function () {
      return original.call(this).filter(function (section) {
        return document.getElementById(section.id);
      });
    };
  });

  window.addEventListener('DOMContentLoaded', function () {
    // Catch quantity edits inside the drawer, which re-render rather than publish
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      new MutationObserver(function () {
        refreshCount();
      }).observe(drawer, { childList: true, subtree: true });
    }

    document.querySelectorAll('[data-pl-cart-toggle]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer || typeof cartDrawer.open !== 'function') return; // let the link navigate
        event.preventDefault();
        cartDrawer.open(link);
      });
    });

    // pageshow fires on bfcache restores, where the markup can be stale
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) refreshCount();
    });
  });
})();
